import { render, staticRenderFns } from "./addStaffPage.vue?vue&type=template&id=8c4debe2&"
import script from "./addStaffPage.vue?vue&type=script&lang=js&"
export * from "./addStaffPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports